module.exports = __webpack_public_path__ + "img/ai-logo.6c38148c.jpg";